module.exports = JSON.parse('{"Primary":"Primario","Recent":"Reciente","All":"Todos","Studies":"Estudios"}')